<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(funcionario, index) in listado">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ funcionario.nombre }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :funcionario="funcionario">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ funcionario.puesto }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
